export const PeriodType = {
    DAYS: { value: 'DAYS', displayName: 'Nap' },
    WEEKS: { value: 'WEEKS', displayName: 'Hét' },
    MONTHS: { value: 'MONTHS', displayName: 'Hónap' },
};
